<template>
<div class="row">
  <div class="col-md-12">
    <div class="card vx-card">
      <div class="card-body" v-loading="loading">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <!-- <h4 class="font-weight-bold">Lista de artículos</h4> -->
            <search-filter @executeSearch="search" :options="[]"></search-filter>
          </div>
          <div>
            <vs-button @click.prevent="downloadReport('excel')">
              <i class="fa fa-file-excel mr-1"></i>
              Exportar Excel
            </vs-button>
            <vs-button @click.prevent="downloadReport('pdf')">
              <i class="fa fa-file-pdf mr-1"></i>
              Exportar PDF
            </vs-button>
          </div>
        </div>

        <div id="data-list-list-view" class="data-list-container mt-5" v-if="items.length">
            <vs-table ref="table" :max-items="perPage" :data="items">
              <template slot="thead">
                <vs-th>Código cabys</vs-th>

                <vs-th>Código interno</vs-th>
                <vs-th>Cod. barras</vs-th>
                <vs-th>SKU</vs-th>
                <vs-th>Nombre</vs-th>
                <vs-th>Costo</vs-th>
                <vs-th>Precio</vs-th>
                <vs-th>Existencia</vs-th>
                <vs-th>Activo</vs-th>
              </template>

              <template slot-scope="{ data }">
                <tbody>
                  <vs-tr :data="item" :key="indextr" v-for="(item, indextr) in data">
                    <vs-td>
                      <el-tooltip class="item" effect="dark"
                        :content="
                          item.cabys_code
                            ? `${item.cabys_code.code} - ${
                                item.cabys_code.name
                              } - Impuesto: ${item.cabys_code.tax_rate}%`
                            : 'S/C'
                        "
                        placement="right"
                      >
                        <span>{{
                          item.cabys_code ? item.cabys_code.code : "S/C"
                        }}</span>
                      </el-tooltip>
                    </vs-td>
                    <vs-td>
                      {{ item.intern_code }}
                    </vs-td>
                    <vs-td>
                      {{ item.barcode }}
                    </vs-td>
                    <vs-td>
                      {{ item.sku }}
                    </vs-td>

                    <vs-td>
                      {{ item.name | truncateText(0, 25) }}
                    </vs-td>

                    <vs-td> {{ item.currency.symbol }} {{ item.cost_price }} </vs-td>

                    <vs-td> {{ item.currency.symbol }} {{ item.price }} </vs-td>

                    <vs-td> {{ item.inventory ? item.inventory.quantity : "" }} </vs-td>

                    <vs-td> {{ item.active == 1 ? "Activo" : "Inactivo" }} </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </div>

          <div class="col-md-12 text-center" v-if="!loading && items.length == 0">
            <p>No hay artículos.</p>
          </div>
      </div>
    </div>
  </div>

  
  </div>
</template>

<script>
import reportsService from "@/services/reports.service";
import SearchFilter from '@/components/SearchFilter.vue';
import RegistersPerPage from '@/components/RegistersPerPage';
import utilitiesService from "@/services/utilities.service";
import helpers from "@/helpers/helpers";

export default {
  name: 'items',
  data() {
    return {
      items: [],
      loading: true,
      loadingSearch: false,
      pageCount : 1,
      perPage: 10,
      page: 1,
      searchData: {},
      item: {
        code: "",
        name: "",
        description: "",
        category: {id: 1, name: "Productos"},
        unit: "",
        tax_type: "",
        price: "",
        currency: "",
        intern_code: "",
        sku: "",
        barcode: "",
        reference: "",
        max_discount: "",
        brand: "",
        cost_price: "",
        sale_price: "",
        utility: "",
        has_inventory: false,
        active: true
      },
      brands: [],
      blobPdf: null,
    }
  },
  methods: {
    changeNumPerPage(num) {
      let searchData = this.searchData;
      searchData.perPage = num
      this.searchData = searchData
      this.getItemProducts(1, this.searchData)
    },
    search(search) {
      this.searchData = search;
      this.searchData.perPage = this.perPage
      this.getItemProducts(1, this.searchData)
    },
    getItemProducts(page = 1, search = {}) {
      reportsService.getReportItemProducts(page, search).then(res => {

        this.items = res.data
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        if(error.response.status == 401) {
          // localStorage.clear();
          // this.$router.push('login');
        }
      })
    },
    downloadReport(type) {
      this.loading = true
      this.searchData.export = type
      reportsService.getReportItemProducts(1, this.searchData)
        .then(res => {
          this.loading = false
          if (type == "excel") helpers.downloadBlob(res.data, `Inventario Productos.xlsx`);
            else if (type == "pdf") {
              this.blobPdf = res.data;
              helpers.downloadBlob(res.data, `Inventario Productos.pdf`);
            }
        })
        .catch((error) => {
          this.loading = false;
          this.blobPdf = null
          this.$message({
            showClose: true,
            message: "Ocurrio un error al cargar el reporte.",
            type: 'error'
          });
        })
        .finally(() => {
            this.loading = false;
            delete this.searchData.export;
          });
    },
    resetForm() {
      let data_form_initial = this.$options.data().item;
      Object.assign(this.$data.item, data_form_initial);
      this.$validator.reset();
    },
    goPage(numPage) {
      this.getItemProducts(numPage, this.searchData);
    },
  },
  watch: {
    page(newVal) {
      this.goPage(newVal);
    }
  },
  created() {
    this.getItemProducts();
  },
  components: {
    SearchFilter,
    RegistersPerPage,
  }
};
</script>

<style scope>

.box-shadow {
  box-shadow: 0 0 2px rgb(136, 124, 124) !important;
}

.oculto {
  display: none;
}

.con-vs-popup .vs-popup {
  width: 700px !important;
}

.el-select-dropdown__item {
  max-width: 600px;
  position: static;
  white-space: break-spaces;
  text-overflow: none;
  /* height: auto !important; */
  height: auto;
  max-height: 60px;
}
</style>
